/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Object containing a position, linestring (track) or polygon.  Based on http://geojson.org/ and https://github.com/dret/GeoJSON-X. Extensions defined are time (timestamp in ISO format, cog (Course Over Ground in degrees 0..360), sog (Speed Over Ground in knots). Please notice extensions in coordinates can be both numbers and string (time)
 * @export
 * @interface GeoJSON
 */
export interface GeoJSON {
    /**
     * 
     * @type {Array<string>}
     * @memberof GeoJSON
     */
    extensions?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof GeoJSON
     */
    coordinates?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof GeoJSON
     */
    type?: GeoJSONTypeEnum;
}


/**
 * @export
 */
export const GeoJSONTypeEnum = {
    Point: 'Point',
    MultiPoint: 'MultiPoint',
    LineString: 'LineString',
    MultiLineString: 'MultiLineString',
    Polygon: 'Polygon',
    MultiPolygon: 'MultiPolygon',
    GeometryCollection: 'GeometryCollection'
} as const;
export type GeoJSONTypeEnum = typeof GeoJSONTypeEnum[keyof typeof GeoJSONTypeEnum];


/**
 * Check if a given object implements the GeoJSON interface.
 */
export function instanceOfGeoJSON(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GeoJSONFromJSON(json: any): GeoJSON {
    return GeoJSONFromJSONTyped(json, false);
}

export function GeoJSONFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeoJSON {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'extensions': !exists(json, 'extensions') ? undefined : json['extensions'],
        'coordinates': !exists(json, 'coordinates') ? undefined : json['coordinates'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function GeoJSONToJSON(value?: GeoJSON | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'extensions': value.extensions,
        'coordinates': value.coordinates,
        'type': value.type,
    };
}

